import { StatsigClient, StatsigProvider, StatsigProviderProps } from "@statsig/react-bindings";
import { QueryClient } from "@tanstack/react-query";
import { HeadContent, Outlet, Scripts, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Fragment } from "react";
import { createPortal } from "react-dom";
import { Toaster } from "sonner";

import { DefaultErrorComponent, NotFoundComponent } from "~/components/error-states";
import { ComposeContextProviders } from "~/context/compose-context-providers";
import { StudioI18nProvider } from "~/context/studio-i18n-provider";
import { statsigClient } from "~/lib/analytics/statsig";
import { registerPrimaryStores } from "~/stores/registry";
import { initializeRootStore } from "~/stores/root";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RouteComponent,
  async beforeLoad() {
    const rootStart = performance.now();
    registerPrimaryStores();

    await initializeRootStore();

    return { rootStart };
  },

  notFoundComponent: NotFoundComponent,
  errorComponent: DefaultErrorComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      {createPortal(<HeadContent />, document.head)}
      <Scripts />
      <ComposeContextProviders
        providers={[
          StudioI18nProvider,
          [StatsigProvider, { client: statsigClient } as StatsigProviderProps<StatsigClient>],
        ]}
      >
        <Toaster richColors position="top-center" theme="dark" />

        <Outlet />

        <TanStackRouterDevtools position="bottom-right" />
      </ComposeContextProviders>
    </Fragment>
  );
}
